// extracted by mini-css-extract-plugin
export default {"mentions__mention":"meokuetxgtUiWvfLCRIw"};